"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
const i0 = require("./camera-nav.component.scss.shim.ngstyle");
const i1 = require("@angular/core");
const i2 = require("./camera-nav.component");
const i3 = require("@angular/router");
const i4 = require("@angular/material/snack-bar");
const i5 = require("@angular/material/dialog");
const i6 = require("./map.component");
const i7 = require("../../commons/map.service");
const i8 = require("../../xs/services/events/application-events.service");
var styles_CameraNavComponent = [i0.styles];
var RenderType_CameraNavComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CameraNavComponent, data: {} });
exports.RenderType_CameraNavComponent = RenderType_CameraNavComponent;
function View_CameraNavComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "zoom-button"]], null, null, null, null, null)), (_l()(), i1.ɵeld(1, 0, null, null, 0, "canvas", [["id", "cameraNavCanvas"]], [[8, "width", 0], [8, "height", 0]], [[null, "mousedown"], [null, "mouseup"], [null, "mousemove"], [null, "mouseout"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("mousedown" === en)) {
        var pd_0 = (_co.doActionFromRegion($event) !== false);
        ad = (pd_0 && ad);
    } if (("mouseup" === en)) {
        var pd_1 = (_co.doUpActionFromRegion($event) !== false);
        ad = (pd_1 && ad);
    } if (("mousemove" === en)) {
        var pd_2 = (_co.update($event) !== false);
        ad = (pd_2 && ad);
    } if (("mouseout" === en)) {
        var pd_3 = (_co.update(false) !== false);
        ad = (pd_3 && ad);
    } return ad; }, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.size; var currVal_1 = _co.size; _ck(_v, 1, 0, currVal_0, currVal_1); }); }
exports.View_CameraNavComponent_0 = View_CameraNavComponent_0;
function View_CameraNavComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "camera-nav", [], null, null, null, View_CameraNavComponent_0, RenderType_CameraNavComponent)), i1.ɵdid(1, 245760, null, 0, i2.CameraNavComponent, [i3.Router, i4.MatSnackBar, i5.MatDialog, i6.MapComponent, i7.MapService, i3.ActivatedRoute, i8.XsApplicationEventsService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_CameraNavComponent_Host_0 = View_CameraNavComponent_Host_0;
var CameraNavComponentNgFactory = i1.ɵccf("camera-nav", i2.CameraNavComponent, View_CameraNavComponent_Host_0, {}, {}, []);
exports.CameraNavComponentNgFactory = CameraNavComponentNgFactory;
